module.exports = __webpack_public_path__ + "static/media/my-ecomm.aa88d064.svg";